__turbopack_context__.v({
  "cellContainer": "TelephoneInput-module__Y4Ctcq__cellContainer",
  "cellInternational": "TelephoneInput-module__Y4Ctcq__cellInternational",
  "cellSelectedCountry": "TelephoneInput-module__Y4Ctcq__cellSelectedCountry",
  "cellStandard": "TelephoneInput-module__Y4Ctcq__cellStandard",
  "inputContainer": "TelephoneInput-module__Y4Ctcq__inputContainer",
  "select": "TelephoneInput-module__Y4Ctcq__select",
  "tableContainer": "TelephoneInput-module__Y4Ctcq__tableContainer",
});
